module.exports = {"431127100":"塔峰镇","431127102":"毛俊镇","431127103":"楠市镇","431127104":"所城镇","431127105":"新圩镇","431127106":"祠堂圩镇","431127107":"土市镇","431127108":"太平圩镇","431127200":"汇源瑶族乡","431127201":"犁头瑶族乡","431127202":"浆洞瑶族乡","431127203":"湘江源瑶族乡","431127204":"大桥瑶族乡","431127205":"荆竹瑶族乡","431127400":"蓝山荆竹林场","431127401":"蓝山浆洞林场","431127402":"蓝山南岭林场","431127403":"蓝山原种场","431127404":"蓝山黄毛岭茶场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431127.json
// module id = 2036
// module chunks = 0